import { render, staticRenderFns } from "./BuyAndNoThanksButtons.vue?vue&type=template&id=3c36c428"
import script from "./BuyAndNoThanksButtons.vue?vue&type=script&lang=js"
export * from "./BuyAndNoThanksButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports